var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'usertype-history-edit',
  created () {
    var today = new Date()
    today.setMonth(today.getMonth() + 2)
    this.afterTwoMonth = new Date(today.getFullYear(), today.getMonth(), 1)

    this.search()
  },
  data () {
    return {
      canValidate: true,
      userImage: null,
      uploadFlg: false,
      user_name: null,
      afterTwoMonth: null,
      user: {
        user_name: null,
        user_name_furigana: null,
        user_firstname: null,
        user_firstname_furigana: null,
        user_sex: null,
        user_birthday_format: null,
        user_age: null,
      },
      change: {
        user_id: null,
        user_type_name_before: null,
        user_type_name_after: null,
        user_type_id_after: null,
        business_type_id_after: null,
        change_day: null,
        user_authority: null
      }
    }
  },
  computed: {
    userDetail: function() {
      return this.$store.getters.userDetailEdit
    },
    usertypes: function() {
      return this.$store.getters.userDetailUserTypes
    },
    businesstypes: function() {
      return this.$store.getters.userDetailBusinessTypes
    },
    validation: function() {
      var v = {
        user_type_id_after: !!this.change.user_type_id_after,
        change_day: this.change.change_day,
        change_day_range: this.change.change_day < this.afterTwoMonth,

        not_input: !!this.change.user_type_id_after &&
                   this.change.change_day < this.afterTwoMonth &&
                   this.change.change_day
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    notify () {
      return this.$store.getters.usertypeHistoryNotify
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goUserLists: function () {
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    search: function() {
      var data = {}
      var self = this
      var callback = function () {
        self.user.user_name = self.userDetail.attributes['user-name']
        self.user.user_firstname = self.userDetail.attributes['user-firstname']
        self.user.user_name_furigana = self.userDetail.attributes['user-name-furigana']
        self.user.user_firstname_furigana = self.userDetail.attributes['user-firstname-furigana']
        self.user.user_sex = self.userDetail.attributes['sex']
        self.user.user_birthday_format = self.userDetail.attributes['user-birthday-format']
        self.user.user_age = self.userDetail.attributes['age-format']

        self.change.user_type_name_before = self.userDetail.attributes['user-type-name']
        self.change.user_type_id_before = self.userDetail.attributes['user-type-id']

        if(self.userDetail.attributes['user-avartar'] != null){
          self.userImage = self.userDetail.attributes['avartar-path'] + '?token=' + self.authToken + "&timestamp=" + self.timeStamp
        }
        var workIndex = 0
        for (var i=0; i < self.usertypes.length; i++) {
          if (self.usertypes[i].id == self.change.user_type_id_before) {
            workIndex = i
            break;
          }
        }
        self.usertypes.splice(workIndex,1)
      }

      this.$store.dispatch('USER_EDIT',  { id: this.$route.params.id, data: data, callback: callback })
    },
    onClickCancel: function () {
      this.$router.push({ path: '/userhistory/' + this.$route.params.id })
    },
    onClickSave: function () {
      var data = {}
      var self = this
      self.canValidate = true
      self.change.user_id = self.$route.params.id
      this.change.change_day = this.change.change_day.getFullYear() + '-' + ("0" + (this.change.change_day.getMonth() + 1)).slice(-2) + '-' + ("0" + this.change.change_day.getDate()).slice(-2)
      data = self.change
      this.$store.dispatch('USERTYPEHISTORY_CREATE', { data: data, callback: this.onSaved })
    },
    onSaved: function (result) {
      this.$router.push('/users/' + this.$route.params.id)
    },
    selectedUserType: function() {
      var self = this
      for(var i=0; i < self.$store.getters.userDetailUserTypes.length; i++){
        var user_type = self.$store.getters.userDetailUserTypes[i]
        if (user_type.id == self.change.user_type_id_after) {
          self.change.user_type_name_after = user_type.attributes['user-type-name']
          self.change.user_authority = user_type.attributes['default-user-authority']
          for(var j=0; j < self.$store.getters.userDetailBusinessTypes.length; j++){
            var business_type = self.$store.getters.userDetailBusinessTypes[j]
            if (user_type.id == business_type.attributes['user-type-id']){
              self.change.business_type_id_after = business_type.id
              break;
            }
          }
          break;
        }
      }
    },
    /** 画像押下 */
    onClickImageModalShow: function () {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = this.userImage
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/usertype-history-edit.js